<template>
  <div class="users-admin-page brick">
    <users-table
      :users="users"
      :invites="invites"
    ></users-table>
  </div>
</template>

<script>

import { getUsers } from '@/firebase/repositories/users';
import { getInvites } from '@/firebase/repositories/invites';
import UsersTable from '@/components/UsersTable';

export default {
  name: 'UsersAdminPage',
  components: {
    UsersTable,
  },
  data() {
    return {
      users: [],
      invites: [],
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      Promise.all([getUsers(), getInvites()])
        .then(([users, invites]) => {
          this.users = users;
          this.invites = invites;
        });
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/containers/UsersAdminPage.vue